export function initScrollReveal() {
  // 檢查依賴，避免後續噴錯
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const ctx = gsap.context(() => {
    
    /**
     * [優化 2] 使用 gsap.matchMedia() 代替手動 window.device 判斷
     * 原因：這是 GSAP 官方處理響應式的標準做法，能自動管理斷點切換時的動畫重設。
     */
    const mm = gsap.matchMedia();
    const BREAKPOINT = 1200;

    mm.add({
      isDesktop: `(min-width: ${BREAKPOINT + 1}px)`,
      isMobile: `(max-width: ${BREAKPOINT}px)`
    }, (context) => {
      // 取得目前的裝置狀態
      const { isMobile } = context.conditions;

      // 集中管理預設值
      const defaults = isMobile 
        ? { duration: 0.8, offset: 40, direction: 'up', stagger: 0.15, start: '85%' }
        : { duration: 0.8, offset: 40, direction: 'up', stagger: 0.15, start: '90%' };

      // 載入標記邏輯保留
      let isInitialLoad = true;
      setTimeout(() => { isInitialLoad = false; }, 100);
      const ON_LOAD_DELAY = 0.6;

      /**
       * [優化 3] 簡化 parseFade 與加強型別轉換
       * 原因：使用 Object.fromEntries 搭配 URLSearchParams 能一行轉物件。
       * 增加型別轉換（coercion）確保從 data-attribute 拿到的字串能正確轉為數字或布林。
       */
      const parseFade = (raw) => {
        if (!raw || raw === 'true') return {};
        const s = String(raw).trim();
        if (s.startsWith('{')) {
          try { return JSON.parse(s); } catch { return {}; }
        }
        
        // 將 query string 轉為物件
        const obj = Object.fromEntries(new URLSearchParams(s));
        
        // 型別轉換優化
        Object.keys(obj).forEach(key => {
          const val = obj[key];
          if (val === 'true') obj[key] = true;
          else if (val === 'false') obj[key] = false;
          else if (/^-?\d+(\.\d+)?$/.test(val)) obj[key] = parseFloat(val);
        });
        return obj;
      };

      const getConfig = ($el) => {
        const desktopCfg = parseFade($el.attr('data-fade'));
        const mobileCfg = parseFade($el.attr('data-fade-mb'));
        return isMobile ? { ...desktopCfg, ...mobileCfg } : desktopCfg;
      };

      // 掃描與過濾目標 (維持原有邏輯，但改用 jQuery 鏈式寫法)
      const $targets = $('[data-fade], [data-fade-mb]').filter(function () {
        const $el = $(this);
        if (!isMobile && $el.attr('data-fade-desktop') === 'false') return false;
        return isMobile ? true : $el.is('[data-fade]');
      });

      if ($targets.length === 0) return;

      /**
       * [優化 4] 幾何屬性快取 (維持你的優秀做法)
       * 原因：避免在迴圈中不斷讀取 offset().top 觸發瀏覽器重繪 (Reflow)。
       */
      const targetData = $targets.map(function() {
        const $el = $(this);
        return { $el, top: $el.offset().top, left: $el.offset().left };
      }).get();

      // 分組 (Rows)
      const rows = [];
      const TOLERANCE = 5;
      targetData.forEach(data => {
        let foundRow = rows.find(r => Math.abs(r.top - data.top) <= TOLERANCE);
        if (foundRow) foundRow.elements.push(data);
        else rows.push({ top: data.top, elements: [data] });
      });

      // 排序與執行動畫
      rows.sort((a, b) => a.top - b.top).forEach((row) => {
        const rowItems = row.elements.sort((a, b) => a.left - b.left);

        rowItems.forEach((item, index) => {
          const $el = item.$el;
          const cfg = getConfig($el);

          /**
           * [優化 5] 使用 Nullish Coalescing (??)
           * 原因：cfg.stagger || defaults.stagger 在設定為 0 時會失效（0 是 Falsy）。
           * 使用 ?? 確保只有在 undefined/null 時才吃預設值。
           */
          const direction = cfg.fade || defaults.direction;
          const duration  = cfg.duration ?? defaults.duration;
          const offsetVal = cfg.offset ?? defaults.offset;
          const startPos  = cfg.start || defaults.start;
          const stagger   = cfg.stagger ?? defaults.stagger;
          const once      = cfg.once === true;
          const reset     = cfg.reset ?? true;
          const ease      = cfg.ease || 'power2.out';
          const delay     = cfg.delay ?? 0;

          // 初始狀態定義
          const startVars = { opacity: 0 };
          if (direction === 'up') startVars.y = offsetVal;
          else if (direction === 'down') startVars.y = -offsetVal;
          else if (direction === 'left') startVars.x = offsetVal;
          else if (direction === 'right') startVars.x = -offsetVal;

          gsap.set($el[0], startVars);

          /**
           * [優化 6] 善用 ScrollTrigger 原生 once 屬性
           * 原因：ScrollTrigger 內建 once: true，觸發後會自動銷毀該 Trigger，節省效能。
           */
          ScrollTrigger.create({
            trigger: $el[0],
            start: `top ${startPos}`,
            once: once, // 直接由 GSAP 處理銷毀邏輯
            onEnter: () => {
              const initialDelay = isInitialLoad ? ON_LOAD_DELAY : 0;
              gsap.to($el[0], {
                opacity: 1,
                x: 0,
                y: 0,
                duration,
                delay: initialDelay + delay + (index * stagger),
                ease,
                overwrite: 'auto', // 確保動畫不衝突
              });
            },
            onLeaveBack: () => {
              // 若 once 為 true，GSAP 會自動銷毀此 Trigger，所以這裡不需處理
              if (!reset || once) return;

              gsap.to($el[0], {
                ...startVars,
                duration: 0.4,
                ease: "power2.in",
                overwrite: 'auto',
              });
            },
          });
        });
      });
    });
  });

  return ctx; 
}